module.exports = __webpack_public_path__ + "static/media/logo.95f238a5.png";